// The package import, not '../../../axios': that module (which configures this
// same global instance) imports the store, and the store imports Utils, which
// imports this file.
import axios from 'axios';

// Chat accepts archives some browsers report with no type.
const DEFAULT_CONTENT_TYPE = 'application/octet-stream';

/**
 * Uploads a file to S3 through a presigned form issued by the API, which picks
 * the file name and limits the type and size. Resolves to that file name.
 *
 * The form is posted with fetch, not axios: the axios defaults add the API
 * bearer token, which S3 would reject.
 */
export const uploadFileS3 = ({ uploadType, file }) => {
  return async () => {
    const uploadRes = await axios.post('/uploads', {
      type: uploadType,
      content_type: file.type || DEFAULT_CONTENT_TYPE
    });
    const { file_name: fileName, url, fields } = uploadRes.data.payload;

    const formData = new FormData();
    Object.entries(fields).forEach(([name, value]) =>
      formData.append(name, value)
    );
    // S3 ignores any form field after the file.
    formData.append('file', file);

    const s3Res = await fetch(url, { method: 'POST', body: formData });
    if (!s3Res.ok) {
      throw new Error(`File upload failed (${s3Res.status}).`);
    }

    return fileName;
  };
};
